import { useLocalStorageState } from "@outschool/local-storage";
import { HAS_WEB_USER_LOGGED_IN } from "@outschool/ui-auth";
import { useMemo } from "react";

export function useHasLoggedIn(): boolean {
  const [hasLoggedIn] = useLocalStorageState(HAS_WEB_USER_LOGGED_IN, false);

  return useMemo(() => {
    return hasLoggedIn;
  }, [hasLoggedIn]);
}
